<div class="brand-toolbar mat-elevation-z2" fxLayout="row" fxLayoutAlign="start center">
  <mat-icon>home</mat-icon>
  <a class="logo-text" routerLink="/">Home</a>
</div>
